import { useState, useEffect } from 'react';

interface Notification {
  name: string;
  location: string;
  action: string;
  avatar: string;
}

export default function Social() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);

  const notifications: Notification[] = [
    {
      name: 'James',
      location: 'Houston',
      action: 'just booked a consultation',
      avatar: 'https://public.readdy.ai/ai/img_res/95e4d640da4e9e43dc17a038c2cbd57a.jpg'
    },
    {
      name: 'Marcus',
      location: 'Atlanta',
      action: 'just started Legacy Elite package',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20black%20man%20headshot%20portrait%20athletic%20confident%20smile%20clean%20simple%20background%20fitness%20strong%20determined%20masculine%20energy&width=80&height=80&seq=social2&orientation=squarish'
    },
    {
      name: 'David',
      location: 'Chicago',
      action: 'lost 34 lbs in 12 weeks',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20african%20american%20man%20headshot%20portrait%20happy%20confident%20smile%20clean%20simple%20background%20fitness%20transformation%20success%20masculine%20energy&width=80&height=80&seq=social3&orientation=squarish'
    },
    {
      name: 'Terrell',
      location: 'Dallas',
      action: 'just completed Foundation package',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20black%20man%20headshot%20portrait%20confident%20determined%20smile%20clean%20simple%20background%20fitness%20motivated%20strong%20masculine%20energy&width=80&height=80&seq=social4&orientation=squarish'
    },
    {
      name: 'Andre',
      location: 'Miami',
      action: 'gained 15 lbs of muscle',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20african%20american%20man%20headshot%20portrait%20athletic%20confident%20smile%20clean%20simple%20background%20fitness%20strong%20determined%20masculine%20energy&width=80&height=80&seq=social5&orientation=squarish'
    },
    {
      name: 'Kevin',
      location: 'Phoenix',
      action: 'just booked a consultation',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20black%20man%20headshot%20portrait%20confident%20smile%20clean%20simple%20background%20fitness%20motivated%20determined%20strong%20masculine%20energy&width=80&height=80&seq=social6&orientation=squarish'
    }
  ];

  useEffect(() => {
    // Show first notification after 2 seconds
    const initialTimer = setTimeout(() => {
      setIsVisible(true);
    }, 2000);

    return () => clearTimeout(initialTimer);
  }, []);

  useEffect(() => {
    if (!isVisible) return;

    // Hide notification after 5 seconds
    const hideTimer = setTimeout(() => {
      setIsVisible(false);
    }, 5000);

    // Show next notification after 7 seconds total (5s visible + 2s hidden)
    const nextTimer = setTimeout(() => {
      setCurrentIndex((prev) => (prev + 1) % notifications.length);
      setIsVisible(true);
    }, 7000);

    return () => {
      clearTimeout(hideTimer);
      clearTimeout(nextTimer);
    };
  }, [isVisible, currentIndex, notifications.length]);

  const current = notifications[currentIndex];

  return (
    <div
      className={`fixed bottom-20 md:bottom-6 left-4 z-40 transition-all duration-500 ease-in-out ${
        isVisible ? 'translate-x-0 opacity-100' : '-translate-x-full opacity-0'
      }`}
      style={{
        maxWidth: '320px',
        pointerEvents: 'none'
      }}
    >
      <div
        className="rounded-lg shadow-2xl p-4 flex items-center gap-3"
        style={{
          background: 'linear-gradient(135deg, #1a1a1a 0%, #0d0d0d 100%)',
          border: '1.5px solid #B8860B',
          backdropFilter: 'blur(10px)'
        }}
      >
        <div className="w-12 h-12 flex-shrink-0 rounded-full overflow-hidden" style={{ border: '2px solid #B8860B' }}>
          <img
            src={current.avatar}
            alt={current.name}
            className="w-full h-full object-cover"
          />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-bold" style={{ color: '#F5D76E' }}>
            {current.name} <span className="font-normal" style={{ color: '#cccccc' }}>from {current.location}</span>
          </p>
          <p className="text-xs mt-0.5" style={{ color: '#999999' }}>
            {current.action}
          </p>
        </div>
        <div className="flex-shrink-0">
          <i className="ri-checkbox-circle-fill text-lg" style={{ color: '#4ade80' }}></i>
        </div>
      </div>
    </div>
  );
}